/**
 * This is the old, old theme. It has been replaced by themeColors.js, however
 * this file is still used directly in some React components. If you need to
 * make an update to the legacy theme, update themeColors.js. If you need to
 * make an update to the newer v2 theme, update themeV2Colors.js
 */
module.exports = {
  black: '#000000',
  // new colors here
  adminColor: '#00EB80',
  attribute: {
    advocate: '#D42CB9',
    automation: '#DC0C70',
    boardMember: '#9029CF',
    corporation: '#00C7D4',
    foundation: '#00A35E',
    government: '#005931',
    recipient: '#14AAEA',
    member: '#EF870C',
    partner: '#6EC517',
    vip: '#EBB814',
    volunteer: '#2C68DD',
  },
  error: {
    contrastText: '#ffffff',
    main: '#ED6257',
    light: '#FFCCCC',
    dark: '#B30000',
  },
  grey: {
    50: '#fbfbfd',
    100: '#f7f7fb',
    300: '#ececec',
    600: '#cccccc',
    900: '#666666',
  },
  primary: {
    main: '#06838C',
    active: '#0175B6',
    focus: '#0175B6',
    hover: '#0175B6',
    dark: '#03484D',
    contrastText: '#ffffff',
  },
  secondary: {
    main: '#5039AD',
    active: '#6B5ADB',
    focus: '#6B5ADB',
    hover: '#6B5ADB',
    dark: '#2A1B66',
    contrastText: '#ffffff',
  },
  tertiary: {
    main: '#06838c',
    light: '#0db3bf',
    dark: '#03484d',
  },
  text: {
    primary: '#08060f',
    secondary: '#3f3e42',
    disabled: '#706e75',
  },
  success: {
    main: '#72C86A',
    light: '#CFFCCF',
    contrastText: '#000000',
  },
  destructive: {
    dark: '#800800',
    light: '#DF3226',
    main: '#B30000',
    contrastText: '#ffffff',
  },
  warning: {
    main: '#ffd464',
    light: '#FFF0BD',
    contrastText: '#000000',
  },
  primaryButton: {
    main: '#5039ad',
    light: '#6B5adb',
    dark: '#2a1b66',
    contrastText: '#ffffff',
  },
  secondaryButton: {
    main: '#c2bae4',
    light: '#cabefd',
    dark: '#9b8ed4',
    contrastText: '#2a1b66',
  },
  subNav: {
    active: '#03DAC6',
  },
  white: '#ffffff',
  chart: {
    1: '#7D3CAF',
    2: '#2A1B66', // secondary.dark
    3: '#CABEFD',
    4: '#DC7700',
    5: '#00A35E', // attribute.foundation
    6: '#85EDF3',
    7: '#DC0C70', // attribute.automation
    8: '#FFCCCC', // error.light
    9: '#FFD601',
    10: '#06838C', // primary.main
  },
  chartHover: {
    1: '#431864',
    2: '#110B29',
    3: '#9B8DB4',
    4: '#AD5E00',
    5: '#005931', // attribute.government,
    6: '#0DB3BF',
    7: '#B30000', // error.dark,
    8: '#ED6257', // error.main,
    9: '#E3B206',
    10: '#03484D', // primary.dark,
  },
};
